import React, { useEffect, useState } from "react";
import TitlePages from "../../../layout/TitlePages";
import ListBadge from "../../../layout/ListBadge";
import Accordion from "../../../layout/Accordion/Accordion";
import AccordionItem from "../../../layout/Accordion/AccordionItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import {
  dataInfo2016,
  remuneracionMensualItems,
  padronProveedoresItems,
} from "../../../data/dataTransparencia";
import Breadcrumbs from "../../../layout/Breadcrumbs";
import "../Transparencia.css";

const InformacionFinanciera = () => {
  const [openItems, setOpenItems] = useState({});

  useEffect(() => {
    document.title = `Información Financiera`;
  }, []);

  const toggleItem = (id) => {
    setOpenItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <div>
      <Breadcrumbs
        path={[
          { label: "Transparencia", url: "/Transparencia" },
          { label: "Información Financiera" },
        ]}
      />
      <TitlePages title="Información Financiera" hideBreadcrumbs={true} />
      <div className="w-75 mx-auto">
        <ol className="list-group mb-0" style={{ fontSize: "18px" }}>
          {/* Remuneración Mensual */}
          <li
            className="list-group-item d-flex justify-content-between align-items-center"
            onClick={() => toggleItem("remuneracionMensual")}
            style={{ cursor: "pointer", userSelect: "none" }}
            role="button"
            aria-expanded={!!openItems["remuneracionMensual"]}
          >
            <div className="ms-2 me-auto">
              <div
                style={{
                  fontWeight: 700,
                  fontFamily: "inherit",
                  color: "inherit",
                  letterSpacing: "normal",
                  WebkitTextStroke: "0px",
                }}
              >
                Remuneración Mensual
              </div>
            </div>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                viewBox="0 0 16 16"
                style={{
                  transform: openItems["remuneracionMensual"] ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.2s ease",
                  color: "#6c757d",
                }}
                aria-hidden="true"
              >
                <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
              </svg>
            </div>
          </li>

          {openItems["remuneracionMensual"] && (
            <li className="list-group-item p-0 border-top-0">
              <ul className="list-group list-group-flush bg-light">
                {remuneracionMensualItems.map((item) => (
                  <li
                    key={item.year}
                    className="list-group-item bg-transparent d-flex align-items-center py-2 px-4 border-0"
                  >
                    <a
                      href={item.url || item.linkItem}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-inline-flex align-items-center text-decoration-none text-dark"
                      style={{ gap: "12px", fontSize: "18px" }}
                    >
                      <FontAwesomeIcon
                        icon={faFilePdf}
                        style={{ color: "#d32f2f", fontSize: "1.4rem" }}
                      />
                      <span>{item.year}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </li>
          )}

          {/* Padrón de Proveedores */}
          <li
            className="list-group-item d-flex justify-content-between align-items-center"
            onClick={() => toggleItem("padronProveedores")}
            style={{ cursor: "pointer", userSelect: "none" }}
            role="button"
            aria-expanded={!!openItems["padronProveedores"]}
          >
            <div className="ms-2 me-auto">
              <div
                style={{
                  fontWeight: 700,
                  fontFamily: "inherit",
                  color: "inherit",
                  letterSpacing: "normal",
                  WebkitTextStroke: "0px",
                }}
              >
                Padrón de Proveedores
              </div>
            </div>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                viewBox="0 0 16 16"
                style={{
                  transform: openItems["padronProveedores"] ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.2s ease",
                  color: "#6c757d",
                }}
                aria-hidden="true"
              >
                <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
              </svg>
            </div>
          </li>

          {openItems["padronProveedores"] && (
            <li className="list-group-item p-0 border-top-0">
              <ul className="list-group list-group-flush bg-light">
                {padronProveedoresItems.map((item) => (
                  <li
                    key={item.year}
                    className="list-group-item bg-transparent d-flex align-items-center py-2 px-4 border-0"
                  >
                    <a
                      href={item.url || item.linkItem}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-inline-flex align-items-center text-decoration-none text-dark"
                      style={{ gap: "12px", fontSize: "18px" }}
                    >
                      <FontAwesomeIcon
                        icon={faFilePdf}
                        style={{ color: "#d32f2f", fontSize: "1.4rem" }}
                      />
                      <span>{item.year}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </li>
          )}
        </ol>
      </div>
      <br />
      <Accordion idAccordion="informacionFinanciera" clasName={"w-75 mx-auto"}>
        {dataInfo2016.map((infoAccordion) => (
          <AccordionItem
            key={infoAccordion.id}
            flushID={infoAccordion.flushID}
            titleItem={infoAccordion.titleItem}
            contentItem={
              <ListBadge
                ifNumbered={""}
                listsBadgeItem={infoAccordion.children}
              />
            }
            idAccordion="informacionFinanciera"
          />
        ))}
      </Accordion>
    </div>
  );
};
export default InformacionFinanciera;
